import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import ImpiantoClimaForm, { ImpiantoClimaFormData, ToImpiantoData } from "./impiantoClimaForm";
import ImpiantiActions from "../ImpiantiClimaActions";
import ClientiActions from "../../customers/customersActions";
import ClientiStore from "../../customers/customersStore";
import { ImpiantoDto, ClienteDto, ApparecchioCategoryType, ImpiantoClimaDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";

const NewImpianto = (cliente: ClienteDto, category: ApparecchioCategoryType) => {
    var impianto = new ImpiantoClimaDto();
    impianto.id = 0;
    impianto.idCliente = cliente.idCliente;
    impianto.codFisComune = cliente.comune?.codFisComune;
    impianto.cap = cliente.cap ?? cliente.comune?.cap;
    impianto.codFrazione = cliente.frazione?.codFrazione;
    impianto.indirizzo = cliente.indirizzo;
    impianto.inheritsAddress = true;
    impianto.type = category;
    return impianto;
}

interface Props extends RouteComponentProps<{ idCliente: string, category: string }> {
    impianto?: ImpiantoDto;
    cliente?: ClienteDto;
}


const ImpiantoEdit = (props: Props) => {
    let { cliente, history, match: { params: { idCliente, category } } } = props;

    useEffect(() => {
        if (idCliente) {
            if (ClientiStore.get(idCliente) == null)
                ClientiActions.getCliente(parseInt(idCliente));
        }
    }, [idCliente])

    const save = async (i: ImpiantoClimaFormData) => {
        const impiantoData = ToImpiantoData(i);
        await ImpiantiActions.add(impiantoData);
        history.replace(links.customerShow(parseInt(idCliente)));

    }
    if (!cliente)
        return <Loading />

    return (
        <ImpiantoClimaForm
            impianto={NewImpianto(cliente, parseInt(category))}
            onSubmit={save}
            onCancel={() => history.goBack()}
        />

    );
}

const cmp1 = attach(ImpiantoEdit, ClientiStore, (store, props) => ({
    cliente: store.get(props.match.params.idCliente) ?? undefined,
}));
export default withRouter(cmp1);